const addresses = {
  GateWayContractAddress: "0x009622Ba90c5f3Cd509fB884Fc358D4B82579429",
};

export { addresses };
